module.exports = {"id":"222986","name":"Masato Morishige","rating":"72","photo":"./data/images/photos/0/222986.png","club":{"name":"F.C. Tokyo","logo":"./data/images/clubs/F.C.Tokyo.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MasatoMorishige0.json
// module id = 2840
// module chunks = 0